/** Single source of truth: authenticated main-region routes (path, pageId, tag, nav). */

export type ShellNavGroup = 'primary' | 'more';

/** Narrow `ShellPorts` surface injected at mount for this route. */
export type ShellRoutePortsType =
  | 'ShellCorePorts'
  | 'SystemShellPorts'
  | 'SyncShellPorts'
  | 'ObservabilityShellPorts'
  | 'EntregaShellPorts'
  | 'ReposicionShellPorts';

export type ShellMainPageManifestEntry = {
  pageId: string;
  path: string;
  customElementTag: string;
  /** Relative to `core/bootstrap/shell/pages/`; lazy-loaded via `shell-routing/infrastructure/shellLazyPageLoad.ts`. */
  pageComponentPath: string;
  shellPortsType: ShellRoutePortsType;
  label: string;
  shortLabel?: string;
  navGroup: ShellNavGroup;
};

export const SHELL_LOGIN_PATH = '/login' as const;
export const SHELL_LOGIN_LABEL = 'Inicio de sesión';

export const SHELL_MAIN_PAGE_MANIFEST: readonly ShellMainPageManifestEntry[] = [
  {
    pageId: 'dashboard',
    path: '/',
    customElementTag: 'dashboard-component',
    pageComponentPath: 'system/DashboardComponent.ts',
    shellPortsType: 'ShellCorePorts',
    label: 'Inicio',
    navGroup: 'primary',
  },
  {
    pageId: 'entrega-paquetes',
    path: '/entrega-paquetes',
    customElementTag: 'entrega-paquetes-page-component',
    pageComponentPath: 'entrega-paquetes/EntregaPaquetesPageComponent.ts',
    shellPortsType: 'EntregaShellPorts',
    label: 'Entrega de paquetes',
    shortLabel: 'Entrega',
    navGroup: 'primary',
  },
  {
    pageId: 'reposicion-productos',
    path: '/reposicion-productos',
    customElementTag: 'reposicion-productos-page-component',
    pageComponentPath: 'reposicion-productos/ReposicionProductosPageComponent.ts',
    shellPortsType: 'ReposicionShellPorts',
    label: 'Reposición de productos',
    shortLabel: 'Reposición',
    navGroup: 'primary',
  },
  {
    pageId: 'sync',
    path: '/sync',
    customElementTag: 'sync-page-component',
    pageComponentPath: 'system/SyncPageComponent.ts',
    shellPortsType: 'SyncShellPorts',
    label: 'Sincronización',
    shortLabel: 'Sinc.',
    navGroup: 'more',
  },
  {
    pageId: 'update-app',
    path: '/actualizar',
    customElementTag: 'update-app-page-component',
    pageComponentPath: 'system/UpdateAppPageComponent.ts',
    shellPortsType: 'SystemShellPorts',
    label: 'Actualizar',
    shortLabel: 'Actualizar',
    navGroup: 'more',
  },
  {
    pageId: 'observability',
    path: '/observability',
    customElementTag: 'observability-page-component',
    pageComponentPath: 'system/ObservabilityPageComponent.ts',
    shellPortsType: 'ObservabilityShellPorts',
    label: 'Observabilidad',
    shortLabel: 'Observ.',
    navGroup: 'more',
  },
];

export function shellManifestNavItems(group: ShellNavGroup): readonly Pick<ShellMainPageManifestEntry, 'path' | 'label' | 'shortLabel'>[] {
  return SHELL_MAIN_PAGE_MANIFEST.filter((entry) => entry.navGroup === group).map(({ path, label, shortLabel }) => ({
    path,
    label,
    shortLabel,
  }));
}
